import { render, staticRenderFns } from "./PygChart.vue?vue&type=template&id=fbfc19ca&scoped=true&"
import script from "./PygChart.vue?vue&type=script&lang=js&"
export * from "./PygChart.vue?vue&type=script&lang=js&"
import style0 from "./PygChart.vue?vue&type=style&index=0&id=fbfc19ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfc19ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
